'use client';

import { c as _c } from "react/compiler-runtime";
import { ChallengeStatus, getDocumentChallengeState, mapChallengeStatus } from '@spa/lib/fastly-challenge/challengeState';
import { CHALLENGE_HOST_CLASS } from '@spa/lib/fastly-challenge/challengeHost';
import { loadChallengeScript } from '@spa/lib/fastly-challenge/challengeScript';
import { useEffect } from 'react';
export default function FastlyChallengeSyncComponent() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  const state = getDocumentChallengeState();
  const host = document.querySelector(`.${CHALLENGE_HOST_CLASS}`);
  if (state.attachHost(host) && host) {
    let previousStatus = null;
    let restoreTabIndex;
    const readStatus = () => {
      const value = host.getAttribute("data-challenge-status");
      const status = mapChallengeStatus(value);
      state.publishStatus(value);
      if (status === ChallengeStatus.CAPTCHA_PROMPTED && previousStatus !== status) {
        const previousActiveElement = document.activeElement;
        const previousTabIndex = host.getAttribute("tabindex");
        host.setAttribute("tabindex", "-1");
        restoreTabIndex = () => {
          if (previousActiveElement instanceof HTMLElement && previousActiveElement.isConnected && host.contains(document.activeElement)) {
            previousActiveElement.focus({
              preventScroll: true
            });
          }
          if (previousTabIndex === null) {
            host.removeAttribute("tabindex");
          } else {
            host.setAttribute("tabindex", previousTabIndex);
          }
        };
        host.focus({
          preventScroll: true
        });
      } else {
        if (status !== ChallengeStatus.CAPTCHA_PROMPTED) {
          restoreTabIndex?.();
          restoreTabIndex = undefined;
        }
      }
      previousStatus = status;
    };
    readStatus();
    const observer = new MutationObserver(readStatus);
    observer.observe(host, {
      attributes: true,
      attributeFilter: ["data-challenge-status"]
    });
    loadChallengeScript();
    return () => {
      observer.disconnect();
      restoreTabIndex?.();
    };
  }
}